import { create } from 'zustand';

// Global UI state. The Rediger toggle (ADR-0022) is the only field at Iter 0;
// add other transient UI flags here as later iterations need them.
interface UIState {
  editMode: boolean;
  setEditMode: (value: boolean) => void;
  toggleEditMode: () => void;
}

export const useUIStore = create<UIState>((set) => ({
  editMode: false,
  setEditMode: (value) => set({ editMode: value }),
  toggleEditMode: () => set((state) => ({ editMode: !state.editMode })),
}));
